module.exports = __webpack_public_path__ + "img/icon_ticket_w.bfffebfe.svg";